import * as types from './types';
import { getErrorMessage, parsePagination, isCancel } from 'utils';
import { uiActions } from 'state/modules/UI';
import * as transactionsAPI from 'services/api/transaction';

// Get transactions list
const fetchTransactionsRequest = () => ({
  type: types.FETCH_TRANSACTIONS_REQUEST,
});

const fetchTransactionsSuccess = (payload) => ({
  type: types.FETCH_TRANSACTIONS_SUCCESS,
  payload,
});

const fetchTransactionsFailed = (error) => ({
  type: types.FETCH_TRANSACTIONS_FAILED,
  error,
});

export const fetchTransactions = (params = {}, options) => {
  return async (dispatch) => {
    dispatch(fetchTransactionsRequest());

    const response = await transactionsAPI.fetchTransactions(params, options);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchTransactionsSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    if (!isCancel(response)) {
      const error = getErrorMessage(response.data);

      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: error,
        })
      );

      dispatch(fetchTransactionsFailed());
    }
  };
};

// Get transaction by ID
const fetchTransactionByIdRequest = () => ({
  type: types.FETCH_TRANSACTIONS_BY_ID_REQUEST,
});

const fetchTransactionByIdSuccess = (payload) => ({
  type: types.FETCH_TRANSACTIONS_BY_ID_SUCCESS,
  payload,
});

const fetchTransactionByIdFailed = (error) => ({
  type: types.FETCH_TRANSACTIONS_BY_ID_FAILED,
  error,
});

export const fetchTransactionById = (id) => {
  return async (dispatch) => {
    dispatch(fetchTransactionByIdRequest());

    const response = await transactionsAPI.fetchTransactionById(id);

    if (response.ok) {
      return dispatch(fetchTransactionByIdSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchTransactionByIdFailed(error));
  };
};
